import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getValueOptions,
  getValueType,
  showDialog,
  showErrorDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";
import paginationFactory from "react-bootstrap-table2-paginator";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectParty,
  fetchParty,
} from "../party/partySlice";
import { fetchLabelTpl, selectLabelTpl } from "../motorPool/motorPoolSlice";
import {
  addPrint,
  fetchPrint,
  fetchVehicleInboundWorkflow,
  fetchVehiclePrint,
  fetchVehiclePrintNoloading,
  selectIdInbound,
  selectInbound,
  selectVehiclePrint,
} from "./inboundSlice";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import debounce from "lodash/debounce";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ModalPrintLabel = ({
  isOpen,
  setShow,
  formValues,
  setFormValues,
  getData,
  setGetData,
  fields,
  id,
  labelTemplate,
  setLabeltemplate,
  vehicle,
  setVehicle,
  dataViewer,
  setDataViewer,
  copy,
  setCopy,
  options,
  setOptions,
  page,
  setPage,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectParty);
  const dataId = useSelector(selectIdInbound);
  const dataLabel = useSelector(selectLabelTpl);
  const dataVehicle = useSelector(selectVehiclePrint);
  const loading = useSelector(selectLoading);

  console.log(page, "page");

  useEffect(() => {
    // Reset on first load
    dispatch(
      fetchLabelTpl({
        is_enable: "Y",
        client_id: dataId.client,
        pageNo: 1,
        pageSize: -1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (getData === true) {
      handleSearch();
      setGetData(false);
    }
  }, [getData]);

  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async () => {
    const params = {
      vehicle_status: "2030",
      is_planned: "Y,N",
      inbound_id: id,
      pageNo: page,
      pageSize: 20,
    };

    try {
      const response = await dispatch(fetchVehiclePrint(params));
      if (response.payload.data.status === 200) {
        const data = response.payload.data.data.map((e) => {
          return {
            value: e.vin,
            label: e.vin + "-" + e.von + "-" + e.engine_no,
          };
        });

        setOptions(data);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleView = async () => {
    if (labelTemplate === "") {
      return showDialog("Please select label template");
    }
    setDataViewer([]);

    const params = {
      vin: vehicle,
      labeltpl_id: labelTemplate,
      copies: 1,
      is_preview: true,
    };
    try {
      const response = await dispatch(fetchPrint(params));
      if (response.payload.data.status === 200) {
        setDataViewer([
          {
            uri: response.payload.data.data.url_preview,
            fileType: "pdf",
            fileName: response.payload.data.data.file_name,
          },
        ]);
      } else if (
        response.payload.data.error === "10008" ||
        response.payload.data.error === "10009"
      ) {
        const action = await showErrorDialog(response.payload.data.message);
        await history.push("/logout");
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handlePrint = async () => {
    const params = {
      vin: vehicle,
      labeltpl_id: labelTemplate,
      copies: copy,
      is_preview: false,
    };
    try {
      const response = await dispatch(addPrint(params));
      if (response.payload.data.status === 200) {
      } else if (
        response.payload.data.error === "10008" ||
        response.payload.data.error === "10009"
      ) {
        const action = await showErrorDialog(response.payload.data.message);
        await history.push("/logout");
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const labelOptions = dataLabel.map((e) => {
    return {
      value: e.labeltpl_id,
      label: e.labeltpl_name,
    };
  });

  const handleChangeLabel = (e) => {
    if (e === null) {
      e = undefined;
      setLabeltemplate("");
    } else {
      setLabeltemplate(e.value);
    }
  };

  const handleChangeVehicle = (e) => {
    if (e === null) {
      e = undefined;
      setVehicle("");
    } else {
      setVehicle(e.value);
    }
  };

  const handleClose = () => {
    setShow(false);
    setDataViewer([]);
    setLabeltemplate("");
    setVehicle("");
  };

  const handleScroll = async (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;

    // Check if the user has reached the bottom of the dropdown
    if (scrollHeight - scrollTop === clientHeight) {
      // Load the next set of options when reaching the scroll limit
      console.log("masuk");
      setPage((prevPage) => prevPage + 1);

      try {
        // Simulate fetching data from the server or another source
        const response = await dispatch(
          fetchVehiclePrintNoloading({
            vehicle_status: "2030",
            is_planned: "Y,N",
            inbound_id: id,
            pageNo: page,
            pageSize: 20,
          })
        );

        const data = response.payload.data.data.map((e) => ({
          value: e.vin,
          label: e.vin + "-" + e.von + "-" + e.engine_no,
        }));

        console.log(data, "masuk");

        // Merge the new options with the existing options
        setOptions((prevOptions) => [...prevOptions, ...data]);
      } catch (error) {
        // Handle errors, e.g., log or show an error message
        console.error("Error fetching data:", error);
      }
    }
  };

  console.log(options, "options");

  // Fungsi debounced untuk mendapatkan data dari API
  const fetchDataFromApi = debounce(async (inputValue) => {
    console.log(inputValue,"inputValue");
    try {
      // Simulate fetching data from the server or another source
      const response = await dispatch(
        fetchVehiclePrintNoloading({
          vin: inputValue,
          vehicle_status: "2030",
          is_planned: "Y,N",
          inbound_id: id,
          pageNo: 1,
          pageSize: 20,
        })
      );

      const data = response.payload.data.data.map((e) => ({
        value: e.vin,
        label: e.vin + "-" + e.von + "-" + e.engine_no,
      })); 
      console.log(data,"inputValue data");
      console.log(response," responseinputValue data");


      // Merge the new options with the existing options
      setOptions(data);
    } catch (error) {
      // Handle errors, e.g., log or show an error message
      console.error("Error fetching data:", error);
    }
  }, 1000);

  const _indexPosition = options.findIndex((item) => item.value === vehicle);

  let indexPosition = _indexPosition + 1;

  const handleNext = async () => {
    setDataViewer([]);
    const index = _indexPosition + 1;
    setVehicle(options[index].value);

    const params = {
      vin: options[index].value,
      labeltpl_id: labelTemplate,
      copies: copy,
      is_preview: true,
    };
    try {
      const response = await dispatch(fetchPrint(params));
      if (response.payload.data.status === 200) {
        setDataViewer([
          {
            uri: response.payload.data.data.url_preview,
            fileType: "pdf",
            fileName: response.payload.data.data.file_name,
          },
        ]);
      } else if (
        response.payload.data.error === "10008" ||
        response.payload.data.error === "10009"
      ) {
        const action = await showErrorDialog(response.payload.data.message);
        await history.push("/logout");
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Print Rci
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Template </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      options={labelOptions}
                      value={getValueOptions(labelTemplate, labelOptions)}
                      onChange={handleChangeLabel}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Vehicle Data</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      options={options}
                      value={getValueOptions(vehicle, options)}
                      onChange={handleChangeVehicle}
                      onMenuScrollToBottom={handleScroll}
                      onInputChange={(inputValue) => {
                        // Panggil fungsi debounced dengan nilai input
                        fetchDataFromApi(inputValue);
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Col sm={6}>
                    <Button className="btn btn-primary" onClick={handleView}>
                      View
                    </Button>
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          {dataViewer.length > 0 && (
            <>
              <hr />
              <p className="font-weight-boldest">Print option</p>
              <Row>
                <Col xs={10} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Number Of Copy"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    fullWidth
                    size="small"
                    type="number"
                    name="copy"
                    value={copy}
                    onChange={(e) => setCopy(e.target.value)}
                  />
                </Col>
              </Row>

              <div class="d-flex bd-highlight">
                <div class="p-2 flex-fill bd-highlight">
                  <Button
                    className="btn btn-primary mr-5"
                    onClick={handlePrint}
                  >
                    Print
                  </Button>
                  <Form.Check
                    inline
                    label="Continuous Printing"
                    name="group1"
                    type="checkbox"
                    className="mr-8 mb-4"
                    // onChange={(e) => {
                    //   if (e.target.checked === true) {
                    //     setCopies("Y");
                    //   } else {
                    //     setCopies("N");
                    //   }
                    // }}
                  />
                </div>
                <div class="p-2 flex-fill bd-highlight mt-2">
                  Record {indexPosition} of {options.length}
                </div>
                {parseInt(indexPosition) !== parseInt(options.length) ? (
                  <div class="p-2 flex-fill bd-highlight">
                    <Button className="btn btn-primary" onClick={handleNext}>
                      Next
                    </Button>
                  </div>
                ) : null}
              </div>
              <DocViewer
                pluginRenderers={DocViewerRenderers}
                documents={dataViewer}
              />
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary">View</Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};
